import { Component, ElementRef, NgZone, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { timer, take } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PrizeBox, PrizeBoxesLevelLottery } from 'src/app/services/client-area/client-area.models';
import { PrizeBoxService } from '../../../services/client-area/prize-box.service';
import { BasePageComponentWithDialogs } from '../../base-page/base-page.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { PrizeInfoDialogComponent } from './prize-info-dialog/prize-info-dialog.component';
import { SMALL_DIALOG_CONFIG } from '../../dialog/dialog.config';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { Router } from '@angular/router';
import { clientAreaMainTrx, clientAreaTrx, infoTrx, treasureBoxesTrx } from 'src/app/router-translation.labels';
import { MinimizeSiteService } from 'src/app/services/utils/hide-footer.service';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { TranslationConfig } from 'src/app/utils/translate-config';


export enum LotteryState {
  EMPTY,
  START,
  NEXT_LEVEL,
  FINISHED
}



@Component({
  selector: 'app-prize-boxes',
  templateUrl: './prize-boxes.component.html',
  styleUrls: ['./prize-boxes.component.scss']
})
export class PrizeBoxesComponent extends BasePageComponentWithDialogs {
  emptyMessage = $localize`:@@empty-prizebox-click:Locked till you reach next gamification level.`;
  readonly treasureBoxInfoUrl: string = `/${this.translationConfig.getTranslation(infoTrx)}/${this.translationConfig.getTranslation(treasureBoxesTrx)}`;

  isShowClickTeaser = true;
  prizeBoxLottery: PrizeBoxesLevelLottery;
  leftToOpen: number;
  showBoxes = false;
  emptyBoxesArray: number[] = Array(9);
  askForNextLevel = false;
  lotteryState: LotteryState = LotteryState.EMPTY;
  lockPrizeBoxClick: Set<number> = new Set<number>();
  lotteryStateEnum = LotteryState;
  isClaimed: boolean;
  isSelectionPrizeVolatilityType: boolean;


  constructor(
    public prizeBoxService: PrizeBoxService,
    private snackBar: MatSnackBar,
    public detectDesktopService: DetectDeviceService,
    public infoDialog: MatDialog,
    public errorDialog: MatDialog,
    public translationConfig: TranslationConfig,
    private router: Router,
    private minimizeFooterService: MinimizeSiteService,
    protected licenceService: LicenceService
  ) {
    super(errorDialog, detectDesktopService);
  }

  ngOnInit(): void {
    this.getPrizeBoxes();
    this.isDesktop = this.detectDesktopService.isDesktop();
  }



  getPrizeBoxes() {
    this.askForNextLevel = false;
    this.prizeBoxService.updateCurrentLevelLottery()
      .pipe(take(1), takeUntil(this.unsubscribe))
      .subscribe((resp) => {
        this.prizeBoxLottery = resp;
        if (resp) {
          this.lockPrizeBoxClick.clear();
          this.isSelectionPrizeVolatilityType = resp.isSelectionPrizeVolatilityType;
          this.leftToOpen = resp.leftToOpen;
          this.showBoxes = true;
          this.isClaimed = true;
          this.lotteryState = LotteryState.START;
        }
      });
  }

  checkIfNextLevel() {
    this.prizeBoxService.updateCurrentLevelLottery()
      .pipe(take(1), takeUntil(this.unsubscribe))
      .subscribe((resp) => {
        if (resp) {
          this.askForNextLevel = true;
          this.lotteryState = LotteryState.NEXT_LEVEL;
        } else {
          this.lotteryState = LotteryState.FINISHED;
        }
      });
  }

  openPrizeBox(prizeBox: PrizeBox): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (prizeBox.isOpen) {
        resolve();
        return;
      }
      if (this.lockPrizeBoxClick.has(prizeBox.index)) {
        resolve();
        return;
      } else {
        this.lockPrizeBoxClick.add(prizeBox.index);
      }
      if (this.leftToOpen > 0) {
        this.leftToOpen -= 1;
        this.prizeBoxService.openPrizeBox(this.prizeBoxLottery.uid, prizeBox)
          .pipe(take(1))
          .subscribe(
            (prize) => {
              prizeBox.prize = prize;
              prizeBox.isOpen = true;
              this.prizeBoxService.initialLottery();
              // if (this.leftToOpen === 0) this.checkIfNextLevel();
              this.lotteryState = LotteryState.FINISHED;
              resolve();
            },
            (error) => {
              this.openErrorDialog();
              reject(error);
            }
          );
        this.isShowClickTeaser = false;
      } else {
        resolve();
      }
    });
  }

  openInfoDialog(): void {
    const dialogRef = this.infoDialog.open(PrizeInfoDialogComponent, {
      ...SMALL_DIALOG_CONFIG
    });
  }

  expand() {
    this.isClaimed = true;
  }

  openInfo() {
    this.snackBar.open(this.emptyMessage, 'X', {
      panelClass: 'my-snackbar',
      duration: 2500
    });
  }

  close() {
    this.router.navigate(['', clientAreaTrx, clientAreaMainTrx]).then(() => {
      this.minimizeFooterService.restorePage();
    });
  }

  selectPrizeBoxType(index: number) {
    this.prizeBoxService
      .postSelectPrizeBoxVolatilityType(this.prizeBoxLottery.uid, this.prizeBoxLottery.selectionPrizeBoxVolatilityNames[index])
      .subscribe({
        next: () => {
          this.getPrizeBoxes();
        },
        error: () => {
          this.openErrorDialog();
        }
      });
  }
}
